<template>
  <div class="loading-page">
    <div class="loader"></div>
  </div>
</template>
